let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lFVEG")).then(() => parcelRequire('lCUbf'));